module.exports = __webpack_public_path__ + "img/13_pc.aa7cb616.gif";